export const EXAMPLE_AREA_M2 = 50;
export const EXAMPLE_AREA_M2 = 50;
